/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Maturity_GcInputs */

const en_gc_resources_compare_maturity_gc = /** @type {(inputs: Gc_Resources_Compare_Maturity_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha; expect compatibility gaps`)
};

const zh_gc_resources_compare_maturity_gc = /** @type {(inputs: Gc_Resources_Compare_Maturity_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha 阶段，兼容性尚不完整`)
};

/**
* | output |
* | --- |
* | "Alpha; expect compatibility gaps" |
*
* @param {Gc_Resources_Compare_Maturity_GcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_maturity_gc = /** @type {((inputs?: Gc_Resources_Compare_Maturity_GcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Maturity_GcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_maturity_gc(inputs)
	return zh_gc_resources_compare_maturity_gc(inputs)
});
export { gc_resources_compare_maturity_gc as "gc.resources.compare.maturity.gc" }